module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAHlBMVEUAAAB4fod4foZ6fod5foZ5fYaAgJV4foeAgIl4fYVKRWBGAAAACXRSTlMAVao5ynoMjhyxMBwqAAAAiklEQVRIx2MYWoAtSAkOVBOwKGCZiQQcsCiwRFYwGYsCSWQFE8lUAHMjTgUw5iBUwDQTJ1AYNAqYBQUrZ84URAMzZ04XFDTA4kVUrw5LBUpKygwMRkpKWBVABcHsUQUjQoGgoAQDQ6Og4KBOtDRWoIQG0BVgANIUICoTXJUKCzYFDlgrNJSKbcgAABwlUPFZaH5pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.png
// module id = vmxF
// module chunks = 54